var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9935 7.99757C20.9931 7.64695 20.9006 7.30259 20.7251 6.99904C20.5496 6.69548 20.2974 6.44341 19.9938 6.2681L12.9959 2.26933C12.692 2.09385 12.3472 2.00146 11.9963 2.00146C11.6453 2.00146 11.3005 2.09385 10.9966 2.26933L3.99872 6.2681C3.69507 6.44341 3.44287 6.69548 3.2674 6.99904C3.09194 7.30259 2.99938 7.64695 2.99902 7.99757V15.9951C2.99938 16.3457 3.09194 16.6901 3.2674 16.9936C3.44287 17.2972 3.69507 17.5493 3.99872 17.7246L10.9966 21.7233C11.3005 21.8988 11.6453 21.9912 11.9963 21.9912C12.3472 21.9912 12.692 21.8988 12.9959 21.7233L19.9938 17.7246C20.2974 17.5493 20.5496 17.2972 20.7251 16.9936C20.9006 16.6901 20.9931 16.3457 20.9935 15.9951V7.99757Z",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29907 6.9978L11.9964 11.9963L20.6937 6.9978",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9963 21.9933V11.9963",
    stroke: "white",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoor);
export default __webpack_public_path__ + "static/media/outdoor.ae9d922aa6bfdf876338c51c52766a3d.svg";
export { ForwardRef as ReactComponent };